module.exports = __webpack_public_path__ + "img/logo-icon-4.ecf69b96.png";